<template>
  <div class="menu-list-subheader">
    <slot />
  </div>
</template>

<style lang="scss" scoped>
@use "@/styles/variables/colors";
@use "@/styles/mixins/typography";

.menu-list-subheader {
  @include typography.small("bold");

  height: 24px;
  padding: 4px 12px;
}
</style>
